// extracted by mini-css-extract-plugin
export default {"integration-tag":"integration-tag","form_input_and_button_field":"form_input_and_button_field","active-tag":"active-tag"};
    if(module.hot) {
      // 1793340218755
      var cssReload = require("/home/vsts/work/1/s/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  